import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from "@angular/common/http";
import { map, Observable, tap } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { DynamicEntityDto, DynamicPropertyDto, DynamicTemplateDto, WorkflowDto } from "./dto";
import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Injectable({
	providedIn: 'root'
})
export class HttpWorkflowService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/workflow', authService);
	}
	public getAll(): Observable<WorkflowDto[]> {
		return super.doGet(true, "/");
	}
	public newWorkflow(): Observable<WorkflowDto> {
		return super.doGet(true, `/new`);
	}
	public get(id: number): Observable<WorkflowDto> {
		return super.doGet(true, `/${id}`);
	}
	public edit(id: number, payload: WorkflowDto): Observable<WorkflowDto> {
		return super.doPost(true, `/${id}`, payload);
	}
	public save(payload: WorkflowDto | FormGroup): Observable<WorkflowDto> {
		return super.doPost(true, `/`, payload);
	}
	public getEmailPlaceholders(id: number|undefined, payload: WorkflowDto): Observable<any> {
		if(id){
			return super.doPost(true, `/${id}/emailPlaceholders`, payload);
		}else{
			return super.doPost(true, `/emailPlaceholders`, payload);
		}

	}
}
